"use strict";

var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var operation_retrier_1 = require("operation-retrier");

var logger_1 = require("./logger");

var connector_1 = require("./connector");

exports.Connector = connector_1.Connector;
var retrierConfig = {
  min: 2000,
  max: 120000,
  randomness: 0.2
};
/**
 * Manages the registrations on ERS service.
 * Deduplicates registrations and manages them automatically
 */

var RegistrarConnector = /*#__PURE__*/function (_connector_1$Connecto) {
  _inherits(RegistrarConnector, _connector_1$Connecto);

  var _super = _createSuper(RegistrarConnector);

  /**
   * Creates new instance of the ERS registrar
   *
   * @param Object configuration
   * @param string notificationId
   * @param string channelType
   * @param Array messageTypes
   */
  function RegistrarConnector(channelType, context, transport, config) {
    var _this;

    _classCallCheck(this, RegistrarConnector);

    _this = _super.call(this, config);
    _this.channelType = channelType;
    _this.context = context;
    _this.transport = transport;
    return _this;
  }

  _createClass(RegistrarConnector, [{
    key: "updateRegistration",
    value: function () {
      var _updateRegistration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(registration, reasons) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!reasons.has('notificationId')) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.removeRegistration();

              case 3:
                if (!(!registration.notificationId || !registration.notificationId.length)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", registration);

              case 5:
                _context.next = 7;
                return this.register(registration);

              case 7:
                return _context.abrupt("return", registration);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateRegistration(_x, _x2) {
        return _updateRegistration.apply(this, arguments);
      }

      return updateRegistration;
    }()
  }, {
    key: "removeRegistration",
    value: function () {
      var _removeRegistration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var url, headers;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.registrationId) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                url = "".concat(this.config.registrarUrl, "/").concat(this.registrationId, "?productId=").concat(this.context.productId);
                headers = {
                  'Content-Type': 'application/json',
                  'X-Twilio-Token': this.config.token
                };
                _context2.prev = 4;
                logger_1.log.trace('Removing registration for ', this.channelType);
                _context2.next = 8;
                return new operation_retrier_1.Retrier(Object.assign(retrierConfig, {
                  maxAttemptsCount: 3
                })).run(function () {
                  return _this2.transport.delete(url, headers);
                });

              case 8:
                logger_1.log.debug('Registration removed for', this.channelType);
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);
                logger_1.log.error('Failed to remove of registration ', this.channelType, _context2.t0);
                throw _context2.t0;

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 11]]);
      }));

      function removeRegistration() {
        return _removeRegistration.apply(this, arguments);
      }

      return removeRegistration;
    }()
  }, {
    key: "register",
    value: function () {
      var _register = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(registration) {
        var _this3 = this;

        var registrarRequest, url, headers, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                logger_1.log.trace('Registering', this.channelType, registration);
                registrarRequest = {
                  endpoint_platform: this.context.platform,
                  channel_type: this.channelType,
                  version: this.context.protocolVersion.toString(),
                  message_types: Array.from(registration.messageTypes),
                  data: {
                    registration_id: registration.notificationId
                  },
                  ttl: 'PT24H'
                };
                url = "".concat(this.config.registrarUrl, "?productId=").concat(this.context.productId);
                headers = {
                  'Content-Type': 'application/json',
                  'X-Twilio-Token': registration.token
                };
                logger_1.log.trace('Creating registration for channel ', this.channelType);
                _context3.prev = 5;
                _context3.next = 8;
                return new operation_retrier_1.Retrier(retrierConfig).run(function () {
                  return _this3.transport.post(url, headers, registrarRequest);
                });

              case 8:
                response = _context3.sent;
                this.registrationId = response.body.id;
                logger_1.log.debug('Registration created: ', response);
                _context3.next = 17;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](5);
                logger_1.log.error('Registration failed: ', _context3.t0);
                throw _context3.t0;

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 13]]);
      }));

      function register(_x3) {
        return _register.apply(this, arguments);
      }

      return register;
    }()
  }]);

  return RegistrarConnector;
}(connector_1.Connector);

exports.RegistrarConnector = RegistrarConnector;